import axios from 'axios';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { Fragment, useState } from 'react';
import EditIcon from '../../images/edit-icon.svg';
import DeleteIcon from '../../images/delete-icon.png';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { ColumnToggle, Search } from 'react-bootstrap-table2-toolkit';
import EditPermissionModal from './EditPermissionModal';
import DeletePermissionModal from './DeletePermissionModal';
// // import { useHistory  } from 'react-router-dom';

const GrievanceAdminTable = ({ permissionAdmin }) => {

    const [modalInfo, setModalInfo] = useState([])
    const [editModal, setOpenEditModal] = useState(false)
    const handleEditModal = () => setOpenEditModal(!editModal)

    const [deleteModal, setOpenDeleteModal] = useState(false)
    const handleDeleteModal = () => setOpenDeleteModal(!deleteModal)


    const { REACT_APP_API_BACKEND_URL } = process.env;

    function optionsFormatter(cell, row, rowIndex, formatExtraData) {
        return (
            <Fragment>
                <div style={{display: 'flex'}}>
                    <img 
                        src={EditIcon} 
                        className='table-icon'
                        style={{maxWidth: '50px'}} 
                        onClick={() => {handleEditModal(); setModalInfo(row)}}
                        alt='editbutton'
                    />
                    <img 
                        src={DeleteIcon} 
                        className='table-icon'
                        style={{maxHeight: '43.5px', marginTop:'2.5px'}}
                        onClick={() => {handleDeleteModal(); setModalInfo(row)}}
                        alt='editbutton'
                    />
                </div>
            </Fragment>
        ); 
    }

    const editGrievancePermission = (editPermission) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/grievance/addgrievancepermission';
        const editPermissionDetails = {
            userID: editPermission.userID,
            userName: editPermission.userName,
            factory: editPermission.factorylist,
            category: editPermission.categorylist,
            roleID: editPermission.selectRole,
            createdBy: editPermission.createdBy
        };

        axios
            .post(url, editPermissionDetails)
            .then(
                (response) =>
                    alert('User role has been edited successfully!'),
                setTimeout(() => {
                    setOpenEditModal(!editModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const deleteGrievancePermission = (deletePermission) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/grievance/addgrievancepermission';
        const deletePermissionDetails = {
            userID: deletePermission.userID,
            userName: deletePermission.userName,
            factory: deletePermission.selectfactory,
            category: deletePermission.selectCategory,
            roleID: deletePermission.selectRole,
            createdBy: deletePermission.createdBy
        };

        // console.log(deletePermissionDetails);

        axios
            .post(url, deletePermissionDetails)
            .then(
                (response) =>
                    alert('User role has been deleted successfully!'),
                setTimeout(() => {
                    setOpenDeleteModal(!deleteModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const columns = [
        { 
            dataField: 'name', 
            text: 'Name', 
            sort: true, 
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' }
        },
        { 
            dataField: 'id', 
            text: 'Badge ID', 
            sort: true, 
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' },
            sortFunc: (a, b, order, dataField, rowA, rowB) => { 
                if (order === 'asc')
                {
                  return parseInt(a) - parseInt(b)
                }
               else if (order === 'desc') {
                  return  parseInt(b) - parseInt(a) 
                }
            },
        },
        { 
            dataField: 'createdDate', 
            text: 'Modified Date', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' },
            formatter: (cell, row) => `${moment(row.createdDate).format('DD/MM/YYYY')}`,
            sortFunc: (a, b, order, dataField, rowA, rowB) => { 
                if (order === 'asc')
                {
                  return Date.parse(a) - Date.parse(b)
                }
               else if (order === 'desc') {
                  return  Date.parse(b) - Date.parse(a) 
                }
            }
        },
        { dataField: 'edit',
            text: 'Options',
            sort: false,
            formatter: optionsFormatter,
            headerStyle: { textAlign: 'center' }, 
            headerAttrs: { width: 120 },
            style: { textAlign: 'center' },
            attrs: { width: 120, className: "EditRow" }
        }
    ] 

    const defaultSorted = [{
        dataField: 'createdDate',
        order: 'desc'
    }];

    const { SearchBar, ClearSearchButton } = Search;
    
    return (
        <Fragment>
            <ToolkitProvider
                keyField='id'
                data={permissionAdmin}
                columns={columns}
                search={ { searchFormatted: true } }
            >
            {
                props => (
                <div style={{marginTop: '10px'}}>
                    <SearchBar { ...props.searchProps } />
                    <ClearSearchButton { ...props.searchProps } />
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                        defaultSorted={ defaultSorted }
                    />
                    <EditPermissionModal
                        show={editModal}
                        handleClose={handleEditModal}
                        modalInfo={modalInfo}
                        onAdd={editGrievancePermission}
                    />
                    <DeletePermissionModal
                        show={deleteModal}
                        handleClose={handleDeleteModal}
                        modalInfo={modalInfo}
                        onDelete={deleteGrievancePermission}
                    />
                </div>
                )
            }
            </ToolkitProvider>
        </Fragment>
    );
};

export default GrievanceAdminTable;
